import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  Channel,
  FundSummaryCalcTypeVisibility,
  FundSummaryData,
  ProductDetailConfiguration,
} from '@types';
import { ModalId } from '@products/base-product-detail.component';
import {
  ModalService,
  SimpleModalConfig,
  DebugService,
  DebugServiceToken,
  ComponentTheme,
  ResponsiveService,
} from '@frk/eds-components';
import { takeUntil } from 'rxjs/operators';
import { Observable, Subject, Subscription } from 'rxjs';
import { AppStateService, SiteConfigService } from '@services';
import { EMDASH } from '@products/utils/constants/product.constants';
import { ProductDetailService } from '@products/product-detail-layout/product-detail.service';

@Component({
  selector: 'ft-summary-international',
  templateUrl: './summary-international.component.html',
  styleUrls: ['./summary-international.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryInternationalComponent
  implements AfterViewInit, OnDestroy, OnInit {
  @Input() brConfig: ProductDetailConfiguration;
  @Input() fundSummaryInfo: FundSummaryData;
  @Input() showRatings: boolean;
  @Input() calcTypeVisibility: FundSummaryCalcTypeVisibility;

  isHandheld$: Observable<boolean>;
  isMobile$: Observable<boolean>;

  dataSubscription: Subscription;
  ModalId = ModalId;
  closeAriaLabel = 'Close';
  EMDASH = EMDASH;
  private unsubscribe$: Subject<void> = new Subject<void>();
  /**
   * Expand All Components for Audit - flag
   */
  isExpandAll = false;
  showMSRating = false;
  public navChangePercentage: string;
  public componentTheme: ComponentTheme;
  public colNumbers: { [k: string]: string | number };
  public hideVIPData = false;

  constructor(
    private siteConfigService: SiteConfigService,
    private modalService: ModalService,
    private appStateService: AppStateService,
    private responsiveService: ResponsiveService,
    private productDetailService: ProductDetailService,
    @Inject(DebugServiceToken) private debugService?: DebugService
  ) {
    this.isHandheld$ = responsiveService.isHandheld$();
    this.isMobile$ = responsiveService.isMobile$();
  }

  ngOnInit(): void {
    this.componentTheme = this.appStateService.getFundHeaderTheme();
    const channel = this.appStateService.getChannel();
    this.colNumbers =
      channel === Channel.BRAZIL ? { s: 3, m: 4, l: 3 } : { s: 2, m: 2, l: 2 };

    if (
      this.siteConfigService.isCanada() ||
      this.siteConfigService.isOffshore()
    ) {
      this.showMSRating = true;
    }

    const fundSummaryInfoNavChg = this.fundSummaryInfo?.nav
      ?.navChangePercentage;

    if (fundSummaryInfoNavChg && fundSummaryInfoNavChg !== EMDASH) {
      this.navChangePercentage = ' (' + fundSummaryInfoNavChg + ')';
    } else {
      this.navChangePercentage = '';
    }
    this.productDetailService.isVIPNonLoggedIn$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((status) => {
        this.hideVIPData = status;
      });
  }

  ngAfterViewInit(): void {
    /**
     * Expand All Components for Audit - implementation
     */
    this.debugService
      .getExpandAllComponents$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((expandAll: boolean) => {
        if (expandAll) {
          this.isExpandAll = true;
          this.viewDetails();
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  viewDetails() {
    const config: SimpleModalConfig = {
      modalId: ModalId.Morningstar_Modal,
      type: 'simple',
      eventName: 'morningstar details',
      eventAction: 'Click',
      isEmbeddedInPage: this.isExpandAll,
    };
    this.modalService.open(ModalId.Morningstar_Modal, config);
  }
}
